module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addEmail":"Add Email","emails":"Emails"},"fr":{"addEmail":"Ajouter un courriel","emails":"Courriels"}}')
  delete Component.options._Ctor
}
